import request from '@/utils/request'
import { getSelectedRegion } from '@/utils/region'

// 获取造价案例分类数据
export function getCostCaseCategory() {
  return request({
    url: '/api/cost_case/getCategory',
    method: 'get'
  })
}

// 获取推荐造价案例数据
export function getRecommendCostCase(params = {}) {
  const query = {
    region: params.region || getSelectedRegion(),
    page: params.page || 1,
    limit: params.limit || 1000
  }
  if (params.category_id !== undefined && params.category_id !== null && params.category_id !== '') {
    query.category_id = params.category_id
  }
  const keyword = (params.keyword || '').trim()
  if (keyword) {
    query.keyword = keyword
  }
  return request({
    url: '/api/cost_case/getRecommendCostCase',
    method: 'get',
    params: query
  })
}

// 获取工业建筑等案例列表数据（分页）
export function getCostCase({ page = 1, limit = 10, category_id, keyword } = {}) {
  const query = {
    page,
    limit,
    region: getSelectedRegion()
  }
  if (category_id !== undefined && category_id !== null && category_id !== '') {
    query.category_id = category_id
  }
  const kw = (keyword || '').trim()
  if (kw) {
    query.keyword = kw
  }
  return request({
    url: '/api/cost_case/getCostCase',
    method: 'get',
    params: query
  })
}

// 获取造价案例详情
export function getCostCaseDetail(id) {
  return request({
    url: '/api/cost_case/getCostCaseDetail',
    method: 'get',
    params: { id }
  })
}

// 创建支付订单
export function createPayOrder(data) {
  return request({
    url: '/api/cost_case/createPayOrder',
    method: 'post',
    data: {
      case_id: data.case_id,
      payment_method: data.payment_method
    }
  })
}

// 收藏/取消收藏造价案例
export function collectCase({ case_id, action }) {
  return request({
    url: '/api/cost_case/collectCase',
    method: 'post',
    data: { case_id, action }
  })
}
